export interface Option
{
  id?:number,
  value: number,
  label: string,
  
}

export interface SocketMessage
{
    type:string,
    message:string
}


export class Alert {
  type: AlertType;
  message: string;
}

export enum AlertType {
  Success,
  Error,
  Info,
  Warning
}

/* Test Email */
/* 
export interface TestEmail
{
  email:string,
  subject:string,  
  message:string
}

export interface HTTPTestEmail
{
  email:string,
  subject:string,  
  message:string
}

export class TestEmailForm implements HTTPTestEmail{    
    public email:string;
    public subject:string;
    public message:string;
    constructor(data : TestEmail) 
    {
        if(data==null)
        {
            this.email          = "";
            this.subject        = "";              
            this.message          =""; 
           
        }
        else
        {   this.email           = data.email;
            this.subject         = data.subject;            
            this.message         = data.message;
            
        }
    }
    public makeform(fb:FormBuilder):FormGroup
    {
        return fb.group({
            email       : [this.email],
            subject    : [this.subject],
            message    : [this.message]
      });
    }

    public saveForm(fg:FormGroup):boolean
    {
        if(fg.valid)
        {
            this.email         = fg.get("email").value;
            this.subject       = fg.get("subject").value;                           
            this.message       = fg.get("message").value;            
            return true;
        }
        else
        {
            return false;
        }
    }
} */